import React, { useEffect, useState } from "react";
import api from "../../../../../../api/axios";

const EditFacilites = ({ facility, onUpdated }) => {
  const [facilityName, setFacilityName] = useState("");

  useEffect(() => {
    if (facility) {
      setFacilityName(facility.name || "");
    }
  }, [facility]);

  const handleEditFacility = async (e) => {
    e.preventDefault();
    if (!facilityName) {
      return;
    }

    try {
      const payload = {
        name: facilityName,
        active: true,
      };
      const result = await api.put(`/pms/amenities/${facility.id}`, payload);
      setFacilityName("");
      onUpdated();
    } catch (error) {
      console.error("Add facility failed:", error);
    }
  };

  return (
    <div
      className="modal fade"
      id="edit-facilites"
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5">Edit Room Facility</h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form onSubmit={handleEditFacility}>
            <div className="modal-body">
              <div className="form-group">
                <label className="form-label text-muted">Facility Name</label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue="Delicious Food"
                  value={facilityName}
                  onChange={(e) => setFacilityName(e.target.value)}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="submit" className="btn btn-primary">
                Update changes
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditFacilites;
